<div class="fh-page">

  <div *ngIf="canCreatePO" class="fh-action-head">
    <button class="rp-button rp-filled rp-primary rp-small" *ngIf="isListRoute" (click)="navigateToCreate()">
      <span class="content-icon one-icon-add"></span>
      New Purchase Order
    </button>
  </div>

  <div class="fh-banner" *ngIf="showBanner">
    <div class="fh-banner__content">
      <p class="fh-banner__title">🚀 Streamline your companies and purchase orders</p>
      <p class="fh-banner__desc">
        Manage clients, track purchase orders, and speed up invoicing effortlessly.
        Everything you need to make your daily workflow faster and smoother.
      </p>
      <button
        class="rp-button rp-filled rp-primary rp-small"
        (click)="navigateToCreate()"
        *ngIf="canCreatePO"
      >
        Learn how
      </button>
    </div>

    <div class="fh-banner__decoration" aria-hidden="true">
      <div class="fh-banner__shape fh-banner__shape--arc-1"></div>
      <div class="fh-banner__shape fh-banner__shape--dot-1"></div>
      <div class="fh-banner__shape fh-banner__shape--square-1"></div>
      <div class="fh-banner__shape fh-banner__shape--circle-1"></div>
      <div class="fh-banner__shape fh-banner__shape--arc-2"></div>
      <div class="fh-banner__shape fh-banner__shape--dot-2"></div>
      <div class="fh-banner__shape fh-banner__shape--square-2"></div>
      <div class="fh-banner__shape fh-banner__shape--arc-3"></div>
    </div>

    <button class="fh-banner__close" (click)="closeBanner()" aria-label="Close banner">
      <span class="one-icon-close-v2"></span>
    </button>
  </div>

  <nav class="fh-tabs" *ngIf="isListRoute">
    <a
      class="fh-tabs__tab"
      routerLink="./companies"
      routerLinkActive="fh-tabs__tab--active"
      *hasPermission="'financial-hub/companies'"
    >
      Companies
    </a>
    <a
      class="fh-tabs__tab"
      routerLink="./purchase-orders"
      routerLinkActive="fh-tabs__tab--active"
      [routerLinkActiveOptions]="{ exact: true }"
      *hasPermission="'financial-hub/purchase-orders'"
    >
      Purchase orders
    </a>
  </nav>

  <div class="fh-content">
    <router-outlet></router-outlet>
  </div>

</div>
